import { gql } from '@apollo/client'

export const FIND_TARGET_CORRECTION_PAYMENT_BY_MEETING_ID = gql`
  query targetCorrectionPaymentByMeetingId($meetingId: HashedId!) {
    targetCorrectionPaymentByMeetingId(meetingId: $meetingId) {
      id
      paymentDate
      status
      resultAmount
      comment
      referenceYear
      meetingId
      paymentDateValid
    }
    targetCorrectionPaymentAllowedYears(meetingId: $meetingId) {
      currentYearAllowed
      previousYearAllowed
    }
  }
`
